import Cookies from 'js-cookie';
let user;
function extractUser() {
    const tokenName = getTokenName(window.cname, window.subdomain);
    const ssoToken = Cookies.get(tokenName);
    if (ssoToken) {
        const payload = ssoToken.split('.')[1];
        const parsedPayload = JSON.parse(window.atob(payload));
        const { userName: email, traits: { userUid: uid }, } = parsedPayload;
        return {
            email,
            uid,
        };
    }
    else {
        return {};
    }
}
export function getInitialData() {
    return window.initialData;
}
export function getUser() {
    if (user)
        return user;
    user = extractUser();
    return user;
}
export function getCompanyUid() {
    return window.companyUid;
}
export function getCompanyName() {
    return window.companyName;
}
export function getCompanyUrl() {
    return window.companyUrl;
}
export function getJSSnippetUrl() {
    return window.jsSnippetUrl;
}
export function getAgentLoginEnabled() {
    return window.agentLoginEnabled;
}
/**
 * Returns the path to where the custom assets are located.
 */
export function getAssetsLocation() {
    return window.assetsLocation;
}
/**
 * Creates the path to where Knowledge Base assets are stored. eg: images, documents etc.
 *
 * - In develeopment the assets are served from the local src/assets folder.
 * - In production the assets are uploaded to Elvio's CDN.
 * @param path path inside `assets` directory. Allows you to gain access to assets you need the url of
 */
export function getAssetURL(path) {
    return `${window.assetsLocation}/${path}`;
}
export function getLanguageId() {
    return window.languageId || 'en'; // the default is just to make testing easier
}
/**
 * This is the language id with the version specifier uppercased
 * ie en-us becomes en-US
 * */
export function getFormattedLanguageId() {
    const langId = getLanguageId();
    if (langId === 'zh-hant')
        return 'zh-Hant';
    const parts = langId.split('-');
    if (parts.length > 1) {
        return `${parts[0]}-${parts[1].toUpperCase()}`;
    }
    return parts[0];
}
export function getLocalisationData() {
    // Do this, so tests still pass
    const customLocalisationData = window.customLocalisationData || {};
    let filteredCustom = {};
    // Filter out the null values
    Object.keys(customLocalisationData).forEach((k) => {
        const t = customLocalisationData[k];
        if (t)
            filteredCustom[k] = t;
    });
    return { ...window.localisationData, ...filteredCustom };
}
export function getCanonicalBaseUrl() {
    return window.baseUrl;
}
export function getFeedbackEnabled() {
    return window.feedbackEnabled;
}
export function getFeedbackEmailFieldHidden() {
    return window.feedbackEmailFieldHidden;
}
export function getSsoEnabled() {
    return window.ssoEnabled;
}
export function getSsoForced() {
    return window.ssoForced;
}
export const getTokenName = (cname, subdomain) => `${cname ? `${cname}-` : ''}${subdomain ? `${subdomain}-` : ''}elevio_token`;
export function getTokenFromCookies() {
    const tokenName = getTokenName(window.cname, window.subdomain);
    return Cookies.get(tokenName);
}
/**
 * Gets a list of suppored language ids that have been injected into the window.
 */
export function getSupoportedLanguages() {
    return window.supportedLanguages;
}
export function getSearchAsYouTypeEnabled() {
    return !!window.searchAsYouTypeEnabled;
}
export function getIsCypressMode() {
    return !!window.Cypress;
}
//# sourceMappingURL=globals.js.map